import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import {
  IconWind, IconShield, IconAlertTri, IconClipboard, IconUserCheck,
  IconCheckCircle, IconPin,
} from '../components/Icons';
import './servicios/ServicePage.css';

const SERVICES = [
  {
    id: 'ventilation',
    Icon: IconWind,
    title: 'Planes de Ventilación',
    desc: 'Elaboramos planes de ventilación técnicos y normativos para minas subterráneas de carbón y otras explotaciones. Realizamos diagnósticos, modelaciones y diseño de redes de ventilación para garantizar condiciones de aire seguras y saludables para los trabajadores.',
    details: [
      'Diagnóstico del sistema de ventilación actual',
      'Modelación y simulación de flujos de aire',
      'Diseño de redes de ventilación principal y auxiliar',
      'Cálculo de requerimientos de ventiladores',
      'Plan de emergencia por falla de ventilación',
      'Informe técnico y normativo para la ANM',
    ],
    norm: 'Decreto 1886 de 2015 – Art. 153 a 178',
  },
  {
    id: 'sostenimiento',
    Icon: IconShield,
    title: 'Planes de Sostenimiento',
    desc: 'Realizamos la caracterización geomecánica del macizo rocoso y diseñamos el sistema de sostenimiento adecuado para cada tipo de labor minera subterránea, garantizando la estabilidad y la seguridad de los trabajadores.',
    details: [
      'Caracterización geomecánica del macizo rocoso',
      'Clasificación RMR y Q del macizo',
      'Diseño de sistemas: cimbras, pernos, malla, shotcrete',
      'Cálculo de cargas y estabilidad de labores',
      'Control y seguimiento de deformaciones',
      'Protocolos de inspección periódica',
    ],
    norm: 'Decreto 1886 de 2015 – Art. 124 a 152',
  },
  {
    id: 'metano-polvo',
    Icon: IconAlertTri,
    title: 'Plan de Prevención Metano y Polvo de Carbón',
    desc: 'Diseñamos planes especializados para la detección, control y prevención de explosiones generadas por acumulación de grisú (CH4) y polvo de carbón en minas subterráneas, incluyendo sistemas de monitoreo y protocolos de respuesta.',
    details: [
      'Monitoreo continuo de gases (CH4, CO, CO2, O2)',
      'Diseño de sistemas de detección y alarma temprana',
      'Protocolos de ventilación anti-grisú',
      'Plan de rociado y captación de polvo de carbón',
      'Capacitación al personal minero en seguridad',
      'Elaboración del PLASER (Plan de Seguridad)',
    ],
    norm: 'Decreto 1886 de 2015 – Art. 179 a 220',
  },
  {
    id: 'pto',
    Icon: IconClipboard,
    title: 'PTO – Plan de Trabajos y Obras',
    desc: 'Elaboramos el Plan de Trabajos y Obras (PTO) conforme a los requisitos técnicos y normativos exigidos por la Agencia Nacional Minera (ANM) para la legalización y ejecución de contratos de concesión minera.',
    details: [
      'Estudio de títulos y caracterización del área',
      'Diseño del método de explotación',
      'Programación de producción y vida de la mina',
      'Plan de inversiones, equipos y costos',
      'Medidas de seguridad e higiene minera',
      'Presentación y seguimiento ante la ANM',
    ],
    norm: 'Ley 685 de 2001 – Código de Minas',
  },
  {
    id: 'asesorias-mineras',
    Icon: IconUserCheck,
    title: 'Asesorías en Temas Mineros',
    desc: 'Ofrecemos acompañamiento técnico y normativo a mineros, empresas y asociaciones en todo tipo de trámites ante la ANM y otras entidades, así como capacitaciones en seguridad minera y cumplimiento de obligaciones legales.',
    details: [
      'Acompañamiento en trámites ante la ANM',
      'Gestión de títulos mineros y contratos de concesión',
      'Asesoría en normatividad minera colombiana',
      'Elaboración de informes de producción y estadísticos',
      'Capacitación técnica y normativa al personal',
      'Apoyo en visitas e inspecciones de autoridades',
    ],
    norm: 'Decreto 1886/2015 – Ley 685/2001',
  },
];

export default function MiningServices() {
  return (
    <div>
      <PageHero
        title="Servicios de Minería"
        subtitle="Planes técnicos, asesorías y documentación normativa para operaciones mineras subterráneas seguras y legales."
        variant="green"
      />

      <section className="section">
        <div className="container">
          <div className="svc-intro">
            <div className="svc-intro__text">
              <div className="divider" />
              <h2 className="section-title">Consultoría Minera Especializada</h2>
              <p>
                Nuestro equipo de ingenieros de minas y especialistas brinda soluciones técnicas
                alineadas con el <strong>Decreto 1886 de 2015</strong> (Reglamento de Seguridad en
                las Labores Mineras Subterráneas), la <strong>Ley 685 de 2001</strong> (Código de
                Minas) y las resoluciones de la <strong>Agencia Nacional Minera (ANM)</strong>.
              </p>
              <p>
                Trabajamos principalmente en el sector carbonífero boyacense y cundinamarqués, con
                experiencia en minas de pequeña, mediana y gran escala.
              </p>
            </div>
            <div className="svc-norm-card">
              <h3>Normativa que manejamos</h3>
              <ul>
                <li>Decreto 1886 de 2015</li>
                <li>Ley 685 de 2001 – Código de Minas</li>
                <li>Resolución 0090 de 2006</li>
                <li>Resolución 0357 de 2002</li>
                <li>Normativa ANM vigente</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--bg">
        <div className="container">
          <div className="divider" />
          <h2 className="section-title">Nuestros Servicios Mineros</h2>
          <div className="svc-list">
            {SERVICES.map(({ id, Icon, title, desc, details, norm }) => (
              <div key={id} className="svc-item">
                <div className="svc-item__icon svc-item__icon--green">
                  <Icon size={28} />
                </div>
                <div className="svc-item__body">
                  <h3>{title}</h3>
                  <p className="svc-item__desc">{desc}</p>
                  <div className="svc-item__details">
                    <h4>Alcance del servicio</h4>
                    <ul>
                      {details.map(d => (
                        <li key={d}>
                          <IconCheckCircle size={15} style={{ color: 'var(--c-green-500)', flexShrink: 0, marginTop: 2 }} />
                          {d}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="svc-item__footer">
                    <span className="svc-norm-badge">
                      <IconPin size={14} />
                      {norm}
                    </span>
                    <Link to="/contacto" className="btn btn--primary btn--sm">Solicitar cotización</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
